import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable, NgZone } from "@angular/core";
import { ApiCommissioningSheetService } from "@app/services/apiservices/api-commissioning-sheet.service";
import { tap } from 'rxjs/operators';
import {
  AddNewUnit,
  GetAllDisciplines,
  GetAllSystemTypes, GetSystemTypes, RemoveNewUnitState
} from "@app/stores/actions/commissioning-sheet.action";
import {CommissioningSheetStateModel} from "@app/stores/models/commissioning-sheet.state.model";
import {AddNewUnitModel} from "@app/models/commissioning-sheet/add-new unit.model";
import {Router} from "@angular/router";

@State<CommissioningSheetStateModel>({
  name: 'CommissioningSheetsState',
  defaults: {
    disciplines: [],
    systemTypes: [],
    unitTemplates: [],
    isCommissioningSheetTemplatesLoaded: false,
    addNewUnit : new AddNewUnitModel()
  }
})

@Injectable()
export class CommissioningSheetState {
  constructor(private apiCommissioningSheetService: ApiCommissioningSheetService, private router: Router, private zone: NgZone ) {
  }

  //// SELECTORS ////
  @Selector()
  static getDisciplineList(state: CommissioningSheetStateModel) {
    return state.disciplines;
  }

  @Selector()
  static getSystemTypeList(state: CommissioningSheetStateModel) {
    return state.systemTypes;
  }

  @Selector()
  static getNewUnit(state: CommissioningSheetStateModel) {
    return state.addNewUnit;
  }
  /// SELECTORS ////

  //// ACTIONS ////
  @Action(GetAllDisciplines)
  getAllDisciplines({getState, setState}: StateContext<CommissioningSheetStateModel>) {
    return this.apiCommissioningSheetService.getAllDisciplines().pipe(
      tap(result => {
        const state = getState();
        setState({
          ...state,
          disciplines: result,
        });
      })
    );
  }

  @Action(GetAllSystemTypes)
  getAllSystemTypes({getState, setState}: StateContext<CommissioningSheetStateModel>) {
    return this.apiCommissioningSheetService.getAllSystemTypes().pipe(
      tap(result => {
        const state = getState();
        setState({
          ...state,
          systemTypes: result
        });
      })
    );
  }

  @Action(GetSystemTypes)
  getSystemTypesFromDiscipline({getState, setState}: StateContext<CommissioningSheetStateModel>, {id}: GetSystemTypes) {
    return this.apiCommissioningSheetService.getSystemTypes(id).pipe(
      tap(result => {
        const state = getState();
        setState({
          ...state,
          systemTypes: result,
        });
      })
    );
  }

  @Action(AddNewUnit)
  addNewController({getState, setState}: StateContext<CommissioningSheetStateModel>, {payload}: AddNewUnit) {
    const state = getState();
    setState({
      ...state,
      addNewUnit: payload,
    });

    this.zone.run(() => {
      this.router.navigate(['/commissioning-sheet/entity-creation']);
    });

  }

  @Action(RemoveNewUnitState)
  removeNewControllerState({getState, setState}: StateContext<CommissioningSheetStateModel>) {
    const state = getState();
    setState({
      ...state,
      addNewUnit: new AddNewUnitModel(),
    });
  }

  //// ACTIONS ////
}
